import { RouteObject } from 'react-router-dom';
import AppLayout from '@/components/feature/AppLayout';
import DashboardPage from '@/pages/dashboard/page';
import LoansPage from '@/pages/loans/page';
import CustomersPage from '@/pages/customers/page';
import ReportsPage from '@/pages/reports/page';
import SettingsPage from '@/pages/settings/page';
import LoginPage from '@/pages/login/page';
import NotFound from '@/pages/NotFound';
import DailyRevenuePage from '@/pages/daily-revenue/page';
import StaffPage from '@/pages/staff/page';
import LoansCreatePage from '@/pages/loans-create/page';
import ForgotPasswordPage from '@/pages/forgot-password/page';
import ResetPasswordPage from '@/pages/reset-password/page';
import ActivityPage from '@/pages/activity/page';
import VehiclePricesPage from '@/pages/vehicle-prices/page';
import ConfiscationsPage from '@/pages/confiscations/page';
import SetupShopPage from '@/pages/setup-shop/page';
import AdminShopsPage from '@/pages/admin-shops/page';
import PrivacyPage from '@/pages/privacy/page';

const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/setup-shop', element: <SetupShopPage /> },
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <DashboardPage /> },
      { path: '/loans', element: <LoansPage /> },
      { path: '/loans/create', element: <LoansCreatePage /> },
      { path: '/customers', element: <CustomersPage /> },
      { path: '/reports', element: <ReportsPage /> },
      { path: '/daily-revenue', element: <DailyRevenuePage /> },
      { path: '/staff', element: <StaffPage /> },
      { path: '/activity', element: <ActivityPage /> },
      { path: '/confiscations', element: <ConfiscationsPage /> },
      { path: '/vehicle-prices', element: <VehiclePricesPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/admin/shops', element: <AdminShopsPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;